import { QueryConfig, QueryState } from 'redux-query';
import { ForceRequestCallback } from 'redux-query-react';
import { AppEntitiesState } from './state';

export type AppQueryConfig = QueryConfig<AppEntitiesState>;

export type UseDataInfo<T> = [T, QueryState, ForceRequestCallback<AppEntitiesState>];

export enum HTTPMethod {
  delete = 'DELETE',
  get = 'GET',
  post = 'POST',
  put = 'PUT',
}
type Entity = {
  [key: string]: string | number | string[] | number[] | boolean;
};

export type Entities = {
  [key: string]: Entity | Entities;
};

type QueryOptions = {
  method?: HTTPMethod;
  headers?: {
    [key: string]: string;
  };
  credentials?: 'include';
  dontCamelizeKeys?: boolean;
  dontDecamelizeKeys?: boolean;
};

/**
 * @deprecated - use `AppQueryConfig` instead
 */
export type RequestQuery = {
  url: string;
  update: {
    [key: string]: (prevValue: any, newValue: any) => any;
  };
  transform?: (responseJson: any, responseText: string) => { [key: string]: Entities };
  body?: {
    [key: string]: any;
  };
  force?: boolean;
  queryKey?: string;
  meta?: {
    [key: string]: any;
  };
  options?: QueryOptions;
};

/**
 * @deprecated - use `AppQueryConfig` instead
 */
export type MutateQuery = {
  optimisticUpdate?: {
    [key: string]: (prevValue: Entities | Entity) => Entities | Entity;
  };
  rollback?: {
    [key: string]: (
      initialValue: Entities | Entity,
      currentValue: Entities | Entity,
    ) => Entities | Entity;
  };
} & RequestQuery;

/**
 * @deprecated - use `AppQueryConfig` instead
 */
export type ReduxQuery = RequestQuery | MutateQuery;
